import { FieldType } from 'src/Common/Filters/interfaces/FiltersView';

export const GSIFilterConfig = [
  {
    fieldId: 'Title',
    fieldName: 'Title',
    fieldType: FieldType.TextField,
    internalName: 'fields/title',
    responseFormat: 'string',
  },
  {
    fieldId: 'AssignedTeam',
    fieldName: 'Assigned Team',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/areapath',
    responseFormat: 'string',
  },
  {
    fieldId: 'ActionOwner',
    fieldName: 'Action Owner',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/assignedto/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'Requestor',
    fieldName: 'Requestor',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/requestorsinfo/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'TPID',
    fieldName: 'TPID',
    fieldType: FieldType.TextField,
    internalName: 'raidrelations/msxaccounts/tpid',
    responseFormat: 'string',
  },
  {
    fieldId: 'PartnerOneId',
    fieldName: 'Partner One ID',
    fieldType: FieldType.CustomDropdown,
    internalName: 'raidrelations/msxaccounts/accounts/oppurtunities/partneroneid',
    responseFormat: 'string',
    isCustomField: true,
  },
  {
    fieldId: 'PartnerOneName',
    fieldName: 'Partner One Name',
    fieldType: FieldType.TextField,
    internalName: 'raidrelations/msxaccounts/accounts/oppurtunities/partneronename',
    responseFormat: 'string',
  },
  {
    fieldId: 'BudgetProgram',
    fieldName: 'Budget Program',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/budgetprogram',
    responseFormat: 'string',
  },
  {
    fieldId: 'CreditAmountUSD',
    fieldName: 'Credit Amount (USD)',
    fieldType: FieldType.Number,
    internalName: 'fields/creditamount',
    responseFormat: 'number',
  },
  {
    fieldId: 'CreditStartDate',
    fieldName: 'Credit Start Date',
    fieldType: FieldType.Date,
    internalName: 'fields/creditstartdate',
    responseFormat: 'date',
  },
  {
    fieldId: 'EnrollmentID',
    fieldName: 'Enrollment ID',
    fieldType: FieldType.TextField,
    internalName: 'fields/enrollmentid',
    responseFormat: 'string',
  },
  {
    fieldId: 'PartnerType',
    fieldName: 'Partner Type',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/partnertype',
    responseFormat: 'string',
  },
  {
    fieldId: 'DealStructure',
    fieldName: 'Deal Structure',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/dealstructure',
    responseFormat: 'string',
  },
  {
    fieldId: 'CommercialExecutiveCE',
    fieldName: 'Commercial Executive (CE)',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/CommercialExecutive/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'EmailsToCC',
    fieldName: 'Enter Emails to CC',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/CustomerEmailsToCC/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'RequestReason',
    fieldName: 'Request Reason',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/requestreason',
    responseFormat: 'string',
  },
  {
    fieldId: 'BusinessJustification',
    fieldName: 'Business Justification',
    fieldType: FieldType.TextField,
    internalName: 'fields/businessjustification',
    responseFormat: 'string',
  },
  {
    fieldId: 'Attachments',
    fieldName: 'Attachments',
    fieldType: FieldType.Attachments,
    internalName: 'fields/attachments',
    responseFormat: 'string',
  },
  {
    fieldId: 'Approver',
    fieldName: 'Approver',
    fieldType: FieldType.PickerComponent,
    internalName: 'fields/approvedBy/uniquename',
    responseFormat: 'string',
  },
  {
    fieldId: 'State',
    fieldName: 'State',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/state',
    responseFormat: 'string',
  },
  {
    fieldId: 'SubState',
    fieldName: 'Sub State',
    fieldType: FieldType.Dropdown,
    internalName: 'fields/substate',
    responseFormat: 'string',
  },
];
